"use client";

import { createContext, useContext, type ReactNode } from "react";

type PlatformAuthBootstrap = {
  /** From RSC `getRequestAuth()` — correct chrome on first paint. */
  initialAuthenticated: boolean;
};

const PlatformAuthContext = createContext<PlatformAuthBootstrap | null>(null);

export function PlatformAuthProvider({
  initialAuthenticated,
  children,
}: PlatformAuthBootstrap & { children: ReactNode }) {
  return (
    <PlatformAuthContext.Provider value={{ initialAuthenticated }}>
      {children}
    </PlatformAuthContext.Provider>
  );
}

export function usePlatformAuthBootstrap(): PlatformAuthBootstrap | null {
  return useContext(PlatformAuthContext);
}
